(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aligan-arc-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllers = new Map();
  function init(root) {
    if (controllers.has(root)) return;
    const track = root.querySelector('[data-arc-track]');
    const items = Array.from(root.querySelectorAll('[data-arc-item]'));
    if (!track || !items.length) return;
    const abort = new AbortController();
    const signal = abort.signal;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const name = root.querySelector('[data-arc-name]');
    const price = root.querySelector('[data-arc-price]');
    const prev = root.querySelector('[data-arc-prev]');
    const next = root.querySelector('[data-arc-next]');
    const progress = root.querySelector('[data-arc-progress]');
    let active = -1, frame = 0, pointer = null, moved = false, previousScroll = track.scrollLeft, sway = 0;
    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
    function draw() {
      frame = 0;
      const width = track.clientWidth;
      const center = track.scrollLeft + width / 2;
      let nearest = 0, distance = Infinity;
      const velocity = track.scrollLeft - previousScroll;
      previousScroll = track.scrollLeft;
      sway = reduced.matches ? 0 : sway * .8 + clamp(-velocity * .08, -3, 3) * .2;
      items.forEach((el, i) => {
        const dx = el.offsetLeft + el.offsetWidth / 2 - center;
        const x = clamp(dx / width + .5, 0, 1);
        const y = 24.389 + 48.611 * (4 * x * (1 - x));
        const turn = reduced.matches ? 0 : clamp(dx / el.offsetWidth * -64, -76, 76);
        el.style.setProperty('--arc-y', (y - 3).toFixed(2) + 'px');
        el.style.setProperty('--arc-turn', turn.toFixed(2) + 'deg');
        el.style.setProperty('--arc-sway', sway.toFixed(2) + 'deg');
        el.style.zIndex = String(100 - Math.round(Math.min(99, Math.abs(dx) / 10)));
        if (Math.abs(dx) < distance) { distance = Math.abs(dx); nearest = i; }
      });
      if (nearest !== active) {
        active = nearest;
        name.textContent = items[active].dataset.title;
        price.textContent = items[active].dataset.price;
        prev.disabled = active === 0;
        next.disabled = active === items.length - 1;
        progress.style.width = ((active + 1) / items.length * 100) + '%';
        items.forEach((el, i) => {
          const pick = el.querySelector('[data-arc-pick]');
          pick.setAttribute('aria-pressed', String(i === active));
        });
      }
      if (Math.abs(sway) > .015 && !reduced.matches) queue();
    }
    function queue() { if (!frame) frame = requestAnimationFrame(draw); }
    function go(index, smooth = true) {
      const el = items[clamp(index, 0, items.length - 1)];
      track.scrollTo({left:el.offsetLeft + el.offsetWidth / 2 - track.clientWidth / 2,behavior:smooth && !reduced.matches ? 'smooth' : 'instant'});
      queue();
    }
    prev.addEventListener('click', () => go(active - 1), {signal});
    next.addEventListener('click', () => go(active + 1), {signal});
    track.addEventListener('scroll', queue, {passive:true,signal});
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1));
    }, {signal});
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointer = {id:event.pointerId,x:event.clientX,scroll:track.scrollLeft};
      moved = false;
    }, {signal});
    track.addEventListener('pointermove', event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (Math.abs(delta) > 5) {
        moved = true;
        track.classList.add('is-dragging');
        if (!track.hasPointerCapture(event.pointerId)) track.setPointerCapture(event.pointerId);
      }
      if (moved) { event.preventDefault(); track.scrollLeft = pointer.scroll - delta; }
    }, {signal});
    function end(event) {
      if (!pointer || event.pointerId !== pointer.id) return;
      if (track.hasPointerCapture(pointer.id)) track.releasePointerCapture(pointer.id);
      pointer = null;
      track.classList.remove('is-dragging');
      if (moved) go(active);
    }
    track.addEventListener('pointerup', end, {signal});
    track.addEventListener('pointercancel', end, {signal});
    track.addEventListener('click', event => {
      if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; return; }
      const item = event.target.closest('[data-arc-item]');
      if (item) go(items.indexOf(item));
    }, {signal});
    track.addEventListener('dragstart', event => event.preventDefault(), {signal});
    root.addEventListener('shopify:block:select', event => {
      const item = event.target.closest('[data-arc-item]');
      if (item) go(items.indexOf(item), false);
    }, {signal});
    const resize = new ResizeObserver(queue);
    resize.observe(track);
    reduced.addEventListener('change', queue, {signal});
    controllers.set(root, () => { abort.abort(); resize.disconnect(); cancelAnimationFrame(frame); });
    go(Math.floor(items.length / 2), false);
    draw();
  }
  function boot(scope) {
    if (scope.matches && scope.matches('[data-arc-rail]')) init(scope);
    scope.querySelectorAll('[data-arc-rail]').forEach(init);
  }
  boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((destroy, root) => {
      if (event.target.contains(root)) { destroy(); controllers.delete(root); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aligan-clothes-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initRail(root) {
    if (root.dataset.alRailV4Ready === '1') return;
    root.dataset.alRailV4Ready = '1';
    const track = root.querySelector('[data-rail-track]');
    const items = track ? Array.from(track.querySelectorAll('[data-rail-piece]')) : [];
    const prev = root.querySelector('[data-rail-prev]');
    const next = root.querySelector('[data-rail-next]');
    const count = root.querySelector('[data-rail-current]');
    const total = root.querySelector('[data-rail-total]');
    const meter = root.querySelector('[data-rail-progress]');
    const detail = root.querySelector('[data-rail-detail]');

    if (!track || !items.length) {
      if (prev) prev.disabled = true;
      if (next) next.disabled = true;
      if (count) count.textContent = '00';
      if (total) total.textContent = '00';
      return;
    }
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let active = -1;
    let pointer = null;
    let moved = false;
    let lastScroll = track.scrollLeft;
    let timer = null;
    let frame = 0;
    const pad = n => String(n).padStart(2, '0');
    if (total) total.textContent = pad(items.length);
    const desiredScroll = i => items[i].offsetLeft + items[i].offsetWidth / 2 - track.clientWidth / 2;
    function closestIndex() {
      const center = track.scrollLeft + track.clientWidth / 2;
      let winner = 0, distance = Infinity;
      items.forEach((el, i) => {
        const d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - center);
        if (d < distance) { winner = i; distance = d; }
      });
      return winner;
    }
    function setDetail(i) {
      if (!detail || detail.dataset.active === String(i)) return;
      const info = items[i].querySelector('.al-rail__info');
      if (!info) return;
      detail.replaceChildren(info.cloneNode(true));
      detail.dataset.active = String(i);
    }
    function sync(i, force) {
      if (active === i && !force) return;
      active = i;
      items.forEach((el, n) => el.classList.toggle('is-active', n === active));
      if (count) count.textContent = pad(active + 1);
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === items.length - 1;
      if (meter) meter.style.width = ((active + 1) / items.length * 100) + '%';
      setDetail(active);
    }
    function go(i, smooth) {
      const index = Math.min(items.length - 1, Math.max(0, i));
      sync(index, true);
      track.scrollTo({left: desiredScroll(index), behavior: smooth && !reduced ? 'smooth' : 'instant'});
    }
    function resetSway() {
      items.forEach(el => el.style.setProperty('--al-tilt', '0deg'));
    }
    function updateFromScroll() {
      frame = 0;
      const now = track.scrollLeft;
      const speed = now - lastScroll;
      lastScroll = now;
      if (!reduced && pointer === null && Math.abs(speed) > .3) {
        const tilt = Math.max(-6, Math.min(6, -speed * .45));
        items.forEach(el => el.style.setProperty('--al-tilt', tilt.toFixed(2) + 'deg'));
      }
      const selected = closestIndex();
      sync(selected, false);
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {resetSway();sync(closestIndex(),true);}, 130);
    }
    prev?.addEventListener('click', () => go(active - 1, true));
    next?.addEventListener('click', () => go(active + 1, true));
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(updateFromScroll);
    }, {passive:true});
    track.addEventListener('keydown', e => {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1,true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1,true); }
      if (e.key === 'Home') { e.preventDefault(); go(0,true); }
      if (e.key === 'End') { e.preventDefault(); go(items.length-1,true); }
    });
    track.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      pointer = {id:e.pointerId,x:e.clientX,scroll:track.scrollLeft};
      moved = false;
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', e => {
      if (!pointer || e.pointerId !== pointer.id) return;
      const delta = e.clientX - pointer.x;
      if (Math.abs(delta) < 5 && !moved) return;
      if (!moved) { moved = true; track.setPointerCapture?.(e.pointerId); }
      track.scrollLeft = pointer.scroll - delta;
      if (!reduced) {
        const tilt = Math.max(-8,Math.min(8,delta*.065));
        items.forEach((el,i) => el.style.setProperty('--al-tilt',(i === active ? tilt : tilt*.55).toFixed(2)+'deg'));
      }
      e.preventDefault();
    });
    function finishDrag() {
      if (!pointer) return;
      pointer = null;
      track.classList.remove('is-dragging');
      if (moved) {
        const i = closestIndex();
        track.scrollTo({left:desiredScroll(i),behavior:reduced?'instant':'smooth'});
        sync(i,true);
      }
      resetSway();
    }
    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    track.addEventListener('lostpointercapture', finishDrag);
    track.addEventListener('click', e => {
      if (!moved) return;
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    }, true);
    track.addEventListener('dragstart', e => e.preventDefault());
    const onResize = () => {
      if (!root.isConnected) return;
      go(Math.max(0,active),false);
    };
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(onResize);
      observer.observe(track);
    } else {
      window.addEventListener('resize',onResize,{passive:true});
    }
    // Show both neighboring jackets on first view so swipe direction is obvious.
    const initial = items.length > 2 ? Math.floor(items.length / 2) : 0;
    sync(initial,true);
    requestAnimationFrame(() => go(initial,false));
  }
  function boot(container) {
    const area = container || document;
    if (area.matches?.('[data-aligan-rail]')) initRail(area);
    area.querySelectorAll?.('[data-aligan-rail]').forEach(initRail);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), {once:true});
  else boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.header = document.getElementById('shopify-section-header');
      if (!this.header) return;

      this.headerBounds = { top: 0, bottom: 0 };
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.headerObserver) {
        this.headerObserver.disconnect();
      }
    }

    setHeaderBounds() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const rect = this.header.getBoundingClientRect();

      this.headerBounds = {
        top: scrollTop + rect.top,
        bottom: scrollTop + rect.bottom
      };

      this.currentScrollTop = this.headerBounds.bottom + 300;
    }

    createObserver() {
      if (!('IntersectionObserver' in window)) {
        this.setHeaderBounds();
        return;
      }

      this.headerObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.length) return;

        this.setHeaderBounds();
        observer.disconnect();
      });

      this.headerObserver.observe(this.header);
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.updateHeaderState();
      });
    }

    updateHeaderState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const headerBottom = this.headerBounds.bottom || 0;
      const headerTop = this.headerBounds.top || 0;

      if (theme.config.mqlSmall) {
        if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
          this.hide();
        } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
          if (!this.preventReveal) {
            this.reveal();
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = window.setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            this.hide();
          }
        } else if (scrollTop <= headerTop) {
          this.reset();
        }

        this.currentScrollTop = scrollTop;
      } else {
        if (scrollTop > this.currentScrollTop) {
          this.reveal();
        } else {
          this.hide();

          if (scrollTop <= headerBottom) {
            this.reset();
          }
        }

        this.currentScrollTop = scrollTop;
      }
    }

    setErwanaNavyState(enabled) {
      this.classList.toggle('erwana-scrolled-navy', enabled);
      this.header.classList.toggle('erwana-scrolled-navy', enabled);
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.setErwanaNavyState(true);
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setErwanaNavyState(true);
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setErwanaNavyState(false);
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
